import React from 'react';
import PropTypes from 'prop-types';

import ListingActionsCard from '../../../../../pro/components/ListingActionsCard';
import { getAsset } from '../../../../../../util/assets';
import Button from '../../../../../../components/global/Button';

const propTypes = {
  onConfigureGallery: PropTypes.func.isRequired,
  onSendGiftNow: PropTypes.func.isRequired,
};

const RegistrationSetupGallery = ({ onConfigureGallery, onSendGiftNow }) => {
  return (
    <div
      data-testid="gift-setup-gallery"
      className="weddings-gift-listing-actions-cards-list"
    >
      <ListingActionsCard
        icon={
          <img
            src={getAsset('/icon-configure-event-blue.svg')}
            alt="Configure an event"
          />
        }
        title="Setup the gallery for the couple before gifting"
        description="You may transfer this event’s ownership to the couple anytime through your event settings."
      >
        <Button
          type="button"
          btnStyle="primary"
          btnBlock
          onClick={onConfigureGallery}
        >
          Setup before sending
        </Button>
      </ListingActionsCard>
      <span className="weddings-gift-listing-actions-cards-separator text-uppercase">
        Or
      </span>
      <ListingActionsCard
        icon={
          <img
            src={getAsset('/icon-transfer-blue.svg')}
            alt="Configure an event"
          />
        }
        title="Send gift now and let the couple setup their gallery"
        description="This event’s ownership will be transferred to the couple. You may still add photos to the event after transferring."
      >
        <Button
          type="button"
          btnStyle="primary"
          btnBlock
          onClick={onSendGiftNow}
        >
          Send gift now
        </Button>
      </ListingActionsCard>
    </div>
  );
};

RegistrationSetupGallery.propTypes = propTypes;

export default RegistrationSetupGallery;
